(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brighton-newsletter-popup"]) return;
  try {
    
if(!customElements.get('flame-newsletter')){customElements.define('flame-newsletter',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.dialog=this.querySelector('dialog');this.teaser=this.querySelector('.flame-newsletter__teaser');
    if(!this.dialog)return;
    this.key='brighton-flame-collectors-v1';
    this.saved=()=>{try{return JSON.parse(localStorage.getItem(this.key)||'{}')}catch{return {}}};
    this.save=value=>{try{localStorage.setItem(this.key,JSON.stringify(value))}catch{}};
    this.open=()=>{if(!this.dialog.open){this.teaser.hidden=true;this.dialog.showModal();document.body.classList.add('flame-newsletter-open')}};
    this.close=()=>this.dialog.close();
    this.querySelector('.flame-newsletter__close').addEventListener('click',this.close);
    this.teaser.addEventListener('click',this.open);
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close()}});
    this.dialog.addEventListener('close',()=>{document.body.classList.remove('flame-newsletter-open');if(!this.saved().subscribed){this.save({dismissedAt:Date.now()});this.teaser.hidden=false}});
    if(this.querySelector('[data-newsletter-success]')){this.save({subscribed:true});this.open();return}
    if(this.querySelector('[data-newsletter-errors]')){this.open();return}
    if(this.saved().subscribed)return;
    this.teaser.hidden=false;
    if(window.Shopify?.designMode)return;
    if(Date.now()-(this.saved().dismissedAt||0)<14*24*60*60*1000)return;
    this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open]'))this.open()},Number(this.dataset.delay)||8000);
  }
  disconnectedCallback(){clearTimeout(this.timer);if(this.dialog?.open)document.body.classList.remove('flame-newsletter-open')}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brighton-scents"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scent-directory')) {
 customElements.define('scent-directory', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.ready) return;
   this.dataset.ready = 'true';
   const nav = this.querySelector('nav');
   nav.hidden = false;
   nav.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-scent]');
    if (!button) return;
    const selected = button.dataset.scent;
    nav.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    let count = 0;
    this.querySelectorAll('[data-family]').forEach(card => {
     const matches = selected === 'all' || card.dataset.family.split(' · ').map(value => value.trim()).includes(selected);
     card.hidden = !matches;
     if (matches) count += 1;
    });
    this.querySelector('[data-count]').textContent = String(count);
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
